<template>
  <div>
    <div style="margin-bottom: 50px;color: #409eff;">
      分销会员申请列表，申请审核通过后即可成为分销会员。
    </div>
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="姓名"
          ><el-input
            size="small"
            v-model="searchForm.name"
            placeholder="请输入姓名"
          ></el-input
        ></el-form-item>
        <el-form-item label="手机号"
          ><el-input
            size="small"
            v-model="searchForm.mobile"
            placeholder="请输入手机号"
          ></el-input
        ></el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="id" label="ID" width="150">
      </el-table-column>
      <el-table-column label="头像" width="150">
        <template slot-scope="scope">
          <img v-img-url="scope.row.imgurl" width="50px" height="50px" />
        </template>
      </el-table-column>
      <el-table-column label="用户信息" width="150">
        <template slot-scope="scope">
          昵称： {{ scope.row.nickname }}<br />
          姓名： {{ scope.row.name }}<br />
          手机号： {{ scope.row.mobile }}<br />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="申请姓名" width="150">
      </el-table-column>

      <el-table-column prop="mobile" label="手机号"> </el-table-column>

      <el-table-column prop="remark" label="申请原因" width="150">
      </el-table-column>
      <el-table-column prop="status_text" label="状态" width="150">
      </el-table-column>

      <el-table-column prop="createTime" label="申请时间"> </el-table-column>

      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="editClick(scope.row)"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <Review
      v-if="open_review"
      :open_edit="open_review"
      :form="userModel"
      @closeDialog="closeDialogFunc($event, 'edit')"
    ></Review>
  </div>
</template>

<script>
import Review from "./review.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    /*编辑组件*/
    Review
  },
  methods: {
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_review = e.openDialog;
        if (e.type == "success") {
        }
      }
    },
    /*打开审核*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_review = true;
    },
    handleClick(row) {
      console.log(row);
    },
    handleCurrentChange() {}
  },

  data() {
    return {
      userModel: {},
      open_review: false,
      activeName: "first",
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 1,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        name: "",
        mobile: ""
      },
      options: [
        {
          value: "选项1",
          label: "审核通过"
        },
        {
          value: "选项2",
          label: "审核拒绝"
        },
        {
          value: "选项3",
          label: "待审核"
        }
      ],
      transoptions: [
        {
          value: "选项1",
          label: "已转账"
        },
        {
          value: "选项2",
          label: "未转账"
        }
      ],
      tableData: [
        {
          id: "1",
          date: "2016-05-02",
          nickname: "w",
          mobile: "1566666666",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          order_num: "5",
          address: "上海市普陀区金沙江路 1518 弄",
          orderNo: 200333,
          matinfo: "毛巾",
          pay: "100",
          money: "99.89",
          level: "1",
          use_money: "22.90",
          total_money: "99.89",
          createTime: "2023年8月29日 12:33",
          order_status_text: "已完成",
          pay_type: "微信",
          type: "申请入驻",
          remark: "好",
          statu: false,
          imgurl: "https://ruanchengshangmen.rchz.top/image/jishi/clock.png",
          status_text: "审核通过"
        }
      ]
    };
  }
};
</script>
<style lang="scss">
.grid-content {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 80%;
  margin-bottom: 50px;
  margin-top: 40px;
  img {
    margin-right: 40px;
  }
  p {
    color: rgba($color: #000000, $alpha: 0.6);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/promotion/user/apply/index.vue